import { render, staticRenderFns } from "./chatView.vue?vue&type=template&id=672dd007&scoped=true&"
import script from "./chatView.vue?vue&type=script&lang=js&"
export * from "./chatView.vue?vue&type=script&lang=js&"
import style0 from "./chatView.vue?vue&type=style&index=0&id=672dd007&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672dd007",
  null
  
)

export default component.exports